import type { SVGProps } from 'react'

export const JobsFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13 15C13 13.8954 13.8954 13 15 13H21C22.1046 13 23 13.8954 23 15V21C23 22.1046 22.1046 23 21 23H15C13.8954 23 13 22.1046 13 21V15Z"
      fill="currentColor"
    />
    <path
      d="M13 3C13 1.89543 13.8954 1 15 1H21C22.1046 1 23 1.89543 23 3V9C23 10.1046 22.1046 11 21 11H15C13.8954 11 13 10.1046 13 9V3Z"
      fill="currentColor"
    />
    <path
      d="M1 15C1 13.8954 1.89543 13 3 13H9C10.1046 13 11 13.8954 11 15V21C11 22.1046 10.1046 23 9 23H3C1.89543 23 1 22.1046 1 21V15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.5C6.27614 1.5 6.5 1.72386 6.5 2L6.5 10C6.5 10.2761 6.27614 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10L5.5 2C5.5 1.72386 5.72386 1.5 6 1.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 6C10.5 6.27614 10.2761 6.5 10 6.5L2 6.5C1.72386 6.5 1.5 6.27614 1.5 6C1.5 5.72386 1.72386 5.5 2 5.5L10 5.5C10.2761 5.5 10.5 5.72386 10.5 6Z"
      fill="currentColor"
    />
  </svg>
)
